import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import {
  SingleTabEditDialog,
  SingleTabEditDialogProps
} from 'record-it-components/modal/SingleTabEditDialog/SingleTabEditDialog';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { PropsWithoutChildren } from 'record-it-components/utils/utilityTypes';
import { EntityName } from 'record-it-time-common/EntityName';
import { TimeTrackingActivityCompilation } from '../../../classes/entities/TimeTrackingActivityCompilation/timeTrackingActivityCompilationTypes';
import { useModifyEntityCallback } from '../../../hooks/entity/useModifyEntityCallback';
import { EditTimeTrackingActivityCompilationForm } from '../EditTimeTrackingActivityCompilationForm/EditTimeTrackingActivityCompilationForm';

export type EditTimeTrackingActivityCompilationDialogProps =
  PropsWithoutChildren<Omit<SingleTabEditDialogProps, 'tabTitle'>> & {
    timeTrackingActivityCompilation: TimeTrackingActivityCompilation;
  };

export const EditTimeTrackingActivityCompilationDialog: FunctionComponent<EditTimeTrackingActivityCompilationDialogProps> =
  React.memo((props) => {
    const { timeTrackingActivityCompilation, ...remainingProps } = prepareProps(
      { props, ignoreChildren: true }
    );

    const { t } = useTranslation();

    const handlePropertyChanged = useModifyEntityCallback(
      EntityName.TimeTrackingActivityCompilation
    );

    return (
      <SingleTabEditDialog
        tabTitle={t(
          'components.timeTrackingActivityCompilation.EditTimeTrackingActivityCompilationDialog.tabTitle'
        )}
        {...remainingProps}
      >
        <EditTimeTrackingActivityCompilationForm
          timeTrackingActivityCompilation={timeTrackingActivityCompilation}
          onPropertyChanged={handlePropertyChanged}
          data-testid="EditTimeTrackingActivityCompilationDialog.EditTimeTrackingActivityCompilationForm"
        ></EditTimeTrackingActivityCompilationForm>
      </SingleTabEditDialog>
    );
  });
